import {
    FETCH_USER_SUBSCRIPTIONS_REQUEST,
    FETCH_USER_SUBSCRIPTIONS_SUCCESS,
    FETCH_USER_SUBSCRIPTIONS_FAILURE
  } from '../actions/types.js';
  
  const initialState = {
    licenseTeamData: null,
    loading: false,
    error: null
  };
  
  const userTeamReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_USER_SUBSCRIPTIONS_REQUEST:
        return {
          ...state,
          loading: true,
          error: null
        };
      case FETCH_USER_SUBSCRIPTIONS_SUCCESS:
        return {
          ...state,
          loading: false,
          licenseTeamData: action.payload,
          error: null
        };
      case FETCH_USER_SUBSCRIPTIONS_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload
        };
      default:
        return state;
    }
  };
  
  export default userTeamReducer;
  